import React from 'react';
import Modal from './Modal';
import './SaveErrorModal.css';

interface SaveErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry?: () => void;
  errorMessage?: string;
}

const SaveErrorModal: React.FC<SaveErrorModalProps> = ({
  isOpen,
  onClose,
  onRetry,
  errorMessage = 'No se pudo guardar el perfil. Por favor, intenta nuevamente.'
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Error al guardar"
      onConfirm={onRetry || onClose}
      confirmText={onRetry ? "Reintentar" : "Entendido"}
      cancelText={onRetry ? "Cancelar" : ""}
    >
      <div className="save-error-content">
        <p>{errorMessage}</p>
        {onRetry && (
          <p className="save-error-hint">
            Si el problema persiste, verifica tu conexión a internet o contacta al soporte.
          </p>
        )}
      </div>
    </Modal>
  );
};

export default SaveErrorModal;
